module.exports = __webpack_public_path__ + "img/packages/bot_row_mobile.dd9a78.png";